/** @format */

import React from "react";
import "../index.css";

export default function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <div className="mb-4">
          <hr />
          <p>&copy; code.it Team, All rights reserved, 2020</p>
          Made with <span style={{ color: "red" }}>♥</span> by{" "}
          <a href="https://www.linkedin.com/in/hazem-a-1954b59a/">Hazem</a> &
          <a href="https://www.linkedin.com/in/abedeljalil-jarjanazy/">
            {" "}
            Jalil
          </a>
        </div>
      </div>
    </div>
  );
}
